

<header id="fh5co-header" class="fh5co-cover fh5co-cover-sm" role="banner" style="background:#cf1f25;;">
    <div class="overlay"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="display-t">
                    <div class="display-tc animate-box" data-animate-effect="fadeIn">
                        <h1 class="inner-title">Contact Us</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
<div id="fh5co-contact">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-12 animate-box">
                        <div class="fh5co-contact-info">
                            <h3>Contact Information</h3>
                            <ul>
                                <li class="email"><a href="mailto:support&#64;thepdfleader.com.com">support&#64;thepdfleader.com</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-12 animate-box">
                        <h3>Get In Touch</h3>
                        <form (ngSubmit)="onSubmit()"  novalidate>
                            <div class="row form-group">
                              <div class="col-md-6">
                                <input 
                                  type="text" 
                                  id="fname" 
                                  class="form-control" 
                                  placeholder="Your firstname" 
                                  [(ngModel)]="contactForm.firstName" 
                                  name="firstName" 
                                  
                                  minlength="2"
                                  #firstName="ngModel"
                                />
                                
                              </div>
                              <div class="col-md-6">
                                <input 
                                  type="text" 
                                  id="lname" 
                                  class="form-control" 
                                  placeholder="Your lastname" 
                                  [(ngModel)]="contactForm.lastName" 
                                  name="lastName" 
                                 
                                  minlength="2"
                                  #lastName="ngModel"
                                />
                               
                              </div>
                            </div>
                            <div class="row form-group">
                              <div class="col-md-12">
                                <input 
                                  type="email" 
                                  id="email" 
                                  class="form-control" 
                                  placeholder="Your email address" 
                                  [(ngModel)]="contactForm.email" 
                                  name="email" 
                                  required
                                  email
                                  #email="ngModel"
                                />
                               
                              </div>
                            </div>
                            <div class="row form-group">
                              <div class="col-md-12">
                                <textarea 
                                  id="message" 
                                  class="form-control" 
                                  placeholder="Your message" 
                                  [(ngModel)]="contactForm.message" 
                                  name="message" 
                                  
                                  minlength="10"
                                  #message="ngModel"
                                ></textarea>
                               
                              </div>
                            </div>
                            <div class="form-group">
                              <button type="submit" class="btn btn-primary" >
                                Send Message
                              </button>
                            </div>
                          </form>
                          <div *ngIf="successMessage" class="alert alert-success mt-3">
                            {{ successMessage }}
                          </div>
                          
                        
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</div>



